const rocketPlayAbi = [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "transactionAmount",
				"type": "uint256"
			}
		],
		"name": "addRocketTokens",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "authorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "claimRewards",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_tokenReward",
				"type": "address"
			}
		],
		"name": "claimRewards",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "_token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "receiver",
				"type": "address"
			}
		],
		"name": "claimRewards",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "manualLPInsertion",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "migratePreviousData",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "tokenAmount",
				"type": "uint256"
			}
		],
		"name": "playBurnPools",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_defaultContract",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "_router",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "_lpToken",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "enum RocketLibrary.TransferType",
				"name": "_transferType",
				"type": "uint8"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "playRocketPools",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_liquidity",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_transferBoost",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_buyBoost",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_burnBoost",
				"type": "uint256"
			}
		],
		"name": "setFees",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_newThreshold",
				"type": "uint256"
			}
		],
		"name": "setLiquiditySwapThreshold",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newToken",
				"type": "address"
			}
		],
		"name": "setNewLPToken",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_previousRocketPlay",
				"type": "address"
			}
		],
		"name": "setPreviousVersion",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_rocketContract",
				"type": "address"
			},
			{
				"internalType": "bool",
				"name": "enabled",
				"type": "bool"
			}
		],
		"name": "setRocketContract",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address payable",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "unauthorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_defaultBurnPoolID",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_defaultBuyPoolID",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_defaultTransferPoolID",
				"type": "uint256"
			}
		],
		"name": "updateDefaultPoolIDs",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_newAddress",
				"type": "address"
			}
		],
		"name": "updateDefaultToken",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenAmount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			}
		],
		"name": "updatePoolByID",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenAmount",
				"type": "uint256"
			}
		],
		"name": "updatePools",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			},
			{
				"internalType": "uint128",
				"name": "chance",
				"type": "uint128"
			},
			{
				"internalType": "uint128",
				"name": "accuracy",
				"type": "uint128"
			},
			{
				"internalType": "uint128",
				"name": "rewardRate",
				"type": "uint128"
			},
			{
				"internalType": "uint128",
				"name": "fee",
				"type": "uint128"
			},
			{
				"internalType": "uint256",
				"name": "requiredAmount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "threshold",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "coolDownTime",
				"type": "uint256"
			}
		],
		"name": "updatePoolSettings",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "_defaultAccuracy",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "_defaultChance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "_defaultHoldAmount",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "_defaultRequired",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "_defaultThreshold",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			}
		],
		"name": "_isInCoolDown",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "_rocketFiPerRocketToken",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "authorizedCreator",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "defaultBurnPoolID",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "defaultBuyPoolID",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "defaultContract",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "defaultToken",
		"outputs": [
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "defaultTransferPoolID",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "fees",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "liquidityReserve",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "transferBoost",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "buyBoost",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "burnBoost",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "getDefaultPoolBalances",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			}
		],
		"name": "getFee",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "fee",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			}
		],
		"name": "getPoolThreshold",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getPreviousData",
		"outputs": [
			{
				"components": [
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "totalBurnPlays",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalTransferPlays",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalBuyPlays",
								"type": "uint256"
							}
						],
						"internalType": "struct RocketLibrary.PlayCounter",
						"name": "playCounter",
						"type": "tuple"
					},
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "totalWonBurnBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalWonBuyBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalClaimedTransferBoost",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastTimeWonBurnPool",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastTimeWonBuyPool",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "lastTimeClaimedTransferPool",
								"type": "uint256"
							}
						],
						"internalType": "struct RocketLibrary.Winnings",
						"name": "winnings",
						"type": "tuple"
					},
					{
						"internalType": "uint256",
						"name": "rocketTokens",
						"type": "uint256"
					}
				],
				"internalType": "struct RocketLibrary.RocketPlayer",
				"name": "",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_tokenReward",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "_holder",
				"type": "address"
			}
		],
		"name": "getUnpaidRewards",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getUserStats",
		"outputs": [
			{
				"internalType": "uint256[]",
				"name": "",
				"type": "uint256[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "isAuthorized",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "isAuthorizedContract",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "isOwner",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "lastRollPublic",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "liquidityReserve",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "liquiditySwapThreshold",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "pair",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "players",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "totalBurnPlays",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalTransferPlays",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalBuyPlays",
						"type": "uint256"
					}
				],
				"internalType": "struct RocketLibrary.PlayCounter",
				"name": "playCounter",
				"type": "tuple"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "totalWonBurnBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalWonBuyBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalClaimedTransferBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "lastTimeWonBurnPool",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "lastTimeWonBuyPool",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "lastTimeClaimedTransferPool",
						"type": "uint256"
					}
				],
				"internalType": "struct RocketLibrary.Winnings",
				"name": "winnings",
				"type": "tuple"
			},
			{
				"internalType": "uint256",
				"name": "rocketTokens",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"name": "playPlatform",
		"outputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "total",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "reserve",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "lastRoll",
				"type": "uint256"
			},
			{
				"components": [
					{
						"internalType": "uint128",
						"name": "chance",
						"type": "uint128"
					},
					{
						"internalType": "uint128",
						"name": "accuracy",
						"type": "uint128"
					},
					{
						"internalType": "uint128",
						"name": "rewardRate",
						"type": "uint128"
					},
					{
						"internalType": "uint128",
						"name": "fee",
						"type": "uint128"
					},
					{
						"internalType": "uint256",
						"name": "requiredAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "threshold",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "coolDownTime",
						"type": "uint256"
					}
				],
				"internalType": "struct RocketPlay.PoolSettings",
				"name": "poolSettings",
				"type": "tuple"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "previousWonAmount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "previousWinTime",
						"type": "uint256"
					},
					{
						"internalType": "address",
						"name": "previousWinner",
						"type": "address"
					}
				],
				"internalType": "struct RocketPlay.WinnerInfo",
				"name": "winnerInfo",
				"type": "tuple"
			},
			{
				"internalType": "enum RocketPlay.PoolType",
				"name": "poolType",
				"type": "uint8"
			},
			{
				"internalType": "address",
				"name": "poolOwner",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "previousPlayers",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "totalBurnPlays",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalTransferPlays",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalBuyPlays",
						"type": "uint256"
					}
				],
				"internalType": "struct RocketLibrary.PlayCounter",
				"name": "playCounter",
				"type": "tuple"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "totalWonBurnBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalWonBuyBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalClaimedTransferBoost",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "lastTimeWonBurnPool",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "lastTimeWonBuyPool",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "lastTimeClaimedTransferPool",
						"type": "uint256"
					}
				],
				"internalType": "struct RocketLibrary.Winnings",
				"name": "winnings",
				"type": "tuple"
			},
			{
				"internalType": "uint256",
				"name": "rocketTokens",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			}
		],
		"name": "rewardBalances",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "router",
		"outputs": [
			{
				"internalType": "contract IDEXRouter",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "poolID",
				"type": "uint256"
			}
		],
		"name": "validatePoolID",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];

export default rocketPlayAbi;